import { z } from 'zod';
/** "No project" — receipts Arbox returns with project_id=null, and every row of a
 *  box that doesn't manage projects. Mirrors the DB sentinel (migration 010). */
export const NO_PROJECT_ID = 0;
export const ProjectSchema = z.object({
    id: z.number(),
    /** Display name. Arbox exposes no project names yet, so this is a fallback
     *  label ("פרויקט 3" / "ללא פרויקט") until it does. */
    name: z.string(),
});
//# sourceMappingURL=projects.js.map